/* eslint-disable @typescript-eslint/no-floating-promises */
import('./bootstrap');
